// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__1cW5E","footer":"ModalInfo_footer__Dcg_x"};